import {useState} from "react";
import {Smartphone, Share, PlusSquare, MoreVertical, Download, Monitor} from "lucide-react";
import {FormModal} from "@/components/UI";

const STEPS = {
  iphone: [[Share, "Open Indian Ocean in Safari and tap the Share button."], [PlusSquare, "Scroll down and tap “Add to Home Screen”."], [Smartphone, "Tap “Add” — the app icon appears on your home screen."]],
  android: [[MoreVertical, "Open Indian Ocean in Chrome and tap the ⋮ menu."], [Download, "Tap “Install app” or “Add to Home screen”."], [Smartphone, "Confirm — it opens full-screen like any other app."]],
  desktop: [[Monitor, "In Chrome or Edge, look for the install icon at the right end of the address bar."], [Download, "Click “Install”."], [Smartphone, "Indian Ocean opens in its own window and lives in your dock or start menu."]],
};

const guessDevice = () => {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "iphone";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
};

export default function InstallGuide({close, installPrompt, onInstall}) {
  const [device, setDevice] = useState(guessDevice);
  return (
    <FormModal title="Get the app — no app store needed." eyebrow="INSTALL INDIAN OCEAN" close={close} width={560} testId="install-guide">
      <p className="modal-sub">Indian Ocean installs straight from your browser in seconds. No downloads from an app store, no updates to manage, and it takes almost no space.</p>
      <div className="activity-tabs">
        {[["iphone", "iPhone / iPad"], ["android", "Android"], ["desktop", "Computer"]].map(([id, label]) => (
          <button key={id} data-testid={`install-tab-${id}`} className={device === id ? "activity-tab active" : "activity-tab"} onClick={() => setDevice(id)}>{label}</button>
        ))}
      </div>
      <ol className="install-steps" data-testid={`install-steps-${device}`}>
        {STEPS[device].map(([Icon, text], i) => (
          <li key={i}><span><Icon size={16}/></span><p><b>{i + 1}.</b> {text}</p></li>
        ))}
      </ol>
      <div className="install-actions">
        {installPrompt && device !== "iphone" && (
          <button data-testid="install-now" className="coral-button" onClick={onInstall}><Download size={15}/> Install now</button>
        )}
        <button data-testid="install-dismiss" className="outline-button" onClick={close}>Got it</button>
      </div>
    </FormModal>
  );
}
